<template>
  <v-dialog
    v-model="getModalVisualizarCrmProposta"
    persistent
    fullscreen
    transition="dialog-transition"
  >
    <v-card outlined>
      <v-card-title>
        <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
          <v-tab>
            <span>DADOS DA VENDA</span>
          </v-tab>

          <v-tab>
            <span>REGISTROS DE ATIVIDADES</span>
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text>
        <v-tabs-items v-model="tabs" class="pa-8">
          <v-tab-item>
            <VCardProposta />
          </v-tab-item>
          <v-tab-item>
            <ListarAtividades />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          @click="setModalVisualizarCrmProposta(false)"
          outlined
          :loading="$store.getters.getOverlay"
          >Voltar</v-btn
        >
        <v-btn
          color="error"
          outlined
          @click="setModalExcluirCrmProposta(true)"
          :loading="$store.getters.getOverlay"
          v-if="$helper.verificaPermissao('excluir-propostas-crm')"
          >Excluir</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          outlined
          @click="modalConfirmacaoConversao = true"
          v-if="getCrmProposta.status != 'CONVERTIDA EM VENDA' && $helper.verificaPermissao('converter-propostas-crm')"
          >Converter em Venda</v-btn
        >
        <!-- <v-btn color="success" outlined @click="setModalFinalizarCrmProposta(true)" v-if="getCrmProposta.status != 'FINALIZADO'"
          >Finalizar</v-btn
        > -->
      </v-card-actions>
    </v-card>
    <ModalExcluir />
    <!-- <ModalVisualizarContato /> -->
    <!-- <ModalFinalizar /> -->
    <v-dialog
      v-model="modalConfirmacaoConversao"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Converter</v-card-title>
        <v-card-text>
          <h3 align="center">
            Tem certeza que deseja converter esta proposta em venda?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            outlined
            @click="modalConfirmacaoConversao = false"
            >Não</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" outlined @click="converterVenda()">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ListarAtividades from "@/pages/crm/proposta/atividade/Listar";
import VCardProposta from "@/pages/crm/proposta/VCardProposta";
import ModalExcluir from "@/pages/crm/proposta/ModalExcluir";
// import ModalFinalizar from "@/pages/crm/CrmProposta/ModalFinalizar";
// import ModalVisualizarContato from "@/pages/contato/ModalCadastro";

export default {
  components: {
    VCardProposta,
    ListarAtividades,
    ModalExcluir,
    // ModalVisualizarContato,
    // ModalFinalizar,
  },
  data() {
    return {
      tabs: 0,
      modalConfirmacaoConversao: false,
    };
  },

  computed: {
    ...mapGetters([
      "getModalVisualizarCrmProposta",
      "getModalCadastroContato",
      "getCrmProposta",
    ]),
  },
  methods: {
    ...mapActions([
      "setModalVisualizarCrmProposta",
      "setModalExcluirCrmProposta",
      "setModalFinalizarCrmProposta",
      "converterOrcamentoParaVenda",
    ]),
    converterVenda() {
      const data = {
        ...this.getCrmProposta.proposta,
        subtotal: this.$helper.formatReal(parseFloat(this.getCrmProposta.proposta.subtotal)),
        desconto: this.$helper.formatReal(parseFloat(this.getCrmProposta.proposta.desconto)),
        total: this.$helper.formatReal(parseFloat(this.getCrmProposta.proposta.total)),
      }
      this.modalConfirmacaoConversao = false;
      this.setModalVisualizarCrmProposta(false);
      this.converterOrcamentoParaVenda(data);
    },
  },
};
</script>